/**
 * Sincronizzazione delle checkbox del carrello tra main cart e drawer
 * Salva lo stato nel session storage per mantenere la persistenza
 */

class CartCheckboxSync {
  constructor() {
    this.STORAGE_KEY = 'cart_checkbox_state';
    this.init();
  }

  init() {
    this.loadState();
    this.attachEventListeners();
    this.observeCartUpdates();
  }

  getCheckboxes() {
    return {
      privacy: document.querySelectorAll('#privacyCheck'),
      newsletter: document.querySelectorAll('#newsletterCheck'),
      profilazione: document.querySelectorAll('#profilazioneCheck')
    };
  }

  getHiddenFields() {
    return {
      newsletter: document.querySelectorAll('#newsletterConsentHidden'),
      profilazione: document.querySelectorAll('#profilingConsentHidden')
    };
  }

  saveState() {
    const state = {};
    const checkboxes = this.getCheckboxes();
    
    if (checkboxes.privacy.length > 0) {
      state.privacy = checkboxes.privacy[0].checked;
    }
    if (checkboxes.newsletter.length > 0) {
      state.newsletter = checkboxes.newsletter[0].checked;
    }
    if (checkboxes.profilazione.length > 0) {
      state.profilazione = checkboxes.profilazione[0].checked;
    }
    
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
  }

  loadState() {
    const savedState = sessionStorage.getItem(this.STORAGE_KEY);
    if (!savedState) return;
    
    try {
      const state = JSON.parse(savedState);
      this.applyState(state);
    } catch (e) {
      console.error('Errore nel caricamento dello stato delle checkbox:', e);
    }
  }

  applyState(state) {
    const checkboxes = this.getCheckboxes();
    const hiddenFields = this.getHiddenFields();
    
    if (state.privacy !== undefined) {
      checkboxes.privacy.forEach(checkbox => {
        checkbox.checked = state.privacy;
        if (!state.privacy) {
          checkbox.value = '';
        } else {
          checkbox.value = 'accepted';
        }
      });
    }
    
    if (state.newsletter !== undefined) {
      checkboxes.newsletter.forEach(checkbox => {
        checkbox.checked = state.newsletter;
      });
      hiddenFields.newsletter.forEach(field => {
        field.value = state.newsletter ? 'true' : 'false';
      });
    }
    
    if (state.profilazione !== undefined) {
      checkboxes.profilazione.forEach(checkbox => {
        checkbox.checked = state.profilazione;
      });
      hiddenFields.profilazione.forEach(field => {
        field.value = state.profilazione ? 'true' : 'false';
      });
    }
  }

  syncCheckboxes(changedCheckbox, type) {
    const checkboxes = this.getCheckboxes();
    const hiddenFields = this.getHiddenFields();
    const isChecked = changedCheckbox.checked;
    
    switch(type) {
      case 'privacy':
        checkboxes.privacy.forEach(checkbox => {
          if (checkbox !== changedCheckbox) {
            checkbox.checked = isChecked;
            checkbox.value = isChecked ? 'accepted' : '';
          }
        });
        break;
        
      case 'newsletter':
        checkboxes.newsletter.forEach(checkbox => {
          if (checkbox !== changedCheckbox) {
            checkbox.checked = isChecked;
          }
        });
        hiddenFields.newsletter.forEach(field => {
          field.value = isChecked ? 'true' : 'false';
        });
        break;
        
      case 'profilazione':
        checkboxes.profilazione.forEach(checkbox => {
          if (checkbox !== changedCheckbox) {
            checkbox.checked = isChecked;
          }
        });
        hiddenFields.profilazione.forEach(field => {
          field.value = isChecked ? 'true' : 'false';
        });
        break;
    }
    
    this.saveState();
  }

  attachEventListeners() {
    document.addEventListener('change', (event) => {
      const target = event.target;
      
      if (target.id === 'privacyCheck') {
        if (!target.checked) {
          target.value = '';
        } else {
          target.value = 'accepted';
        }
        this.syncCheckboxes(target, 'privacy');
      } else if (target.id === 'newsletterCheck') {
        this.syncCheckboxes(target, 'newsletter');
      } else if (target.id === 'profilazioneCheck') {
        this.syncCheckboxes(target, 'profilazione');
      }
    });
  }

  observeCartUpdates() {
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        this.loadState();
        this.attachEventListeners();
      }, 100);
    });

    const cartForms = document.querySelectorAll('cart-form');
    cartForms.forEach(form => {
      observer.observe(form, {
        childList: true,
        subtree: true
      });
    });

    window.addEventListener('cart:updated', () => {
      setTimeout(() => {
        this.loadState();
      }, 100);
    });

    if (typeof MCEVENTS !== 'undefined') {
      window.addEventListener(MCEVENTS.CART_UPDATED, () => {
        setTimeout(() => {
          this.loadState();
        }, 100);
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartCheckboxSync();
  });
} else {
  new CartCheckboxSync();
}